module.exports = __webpack_public_path__ + "static/media/edit@2x.a85185e6.svg";